var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_vm._v(" comment ")])
}
var staticRenderFns = []

export { render, staticRenderFns }